import { __decorate, __extends } from "tslib";
import { Component, Prop } from "vue-property-decorator";
import Vue from "vue";
import { ProgressBarItemState } from "./progress-bar-item";
import PRGLink from '../prg/PRGLink.vue';
/**
 * Generic progress bar implementation
 */
var ProgressBarVue = /** @class */ (function (_super) {
    __extends(ProgressBarVue, _super);
    function ProgressBarVue() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ProgressBarVue.prototype, "calculatedItems", {
        get: function () {
            var _this = this;
            var calculatedItems = [];
            if (this.items) {
                this.items.forEach(function (item, index) {
                    var calculatedItem = {
                        step: index + 1,
                        id: "progress-bar-item-" + (index + 1),
                        state: _this.getItemState(_this.currentStep, index),
                        text: item.text,
                        link: item.link
                    };
                    calculatedItems.push(calculatedItem);
                });
            }
            return calculatedItems;
        },
        enumerable: false,
        configurable: true
    });
    ProgressBarVue.prototype.getItemState = function (currentStep, index) {
        if (currentStep === index && this.finished) {
            return ProgressBarItemState.CURRENT_FINISHED;
        }
        else if (currentStep === index) {
            return ProgressBarItemState.CURRENT;
        }
        else if (currentStep > index) {
            return ProgressBarItemState.PREVIOUS;
        }
        else {
            return ProgressBarItemState.NEXT;
        }
    };
    ProgressBarVue.prototype.isPreviousState = function (state) {
        return state == ProgressBarItemState.PREVIOUS;
    };
    ProgressBarVue.prototype.getItemClass = function (state) {
        return "c-progressbar__item--" + state;
    };
    __decorate([
        Prop({ default: 0 })
    ], ProgressBarVue.prototype, "currentStep", void 0);
    __decorate([
        Prop()
    ], ProgressBarVue.prototype, "items", void 0);
    __decorate([
        Prop({ default: false })
    ], ProgressBarVue.prototype, "finished", void 0);
    ProgressBarVue = __decorate([
        Component({
            components: {
                PRGLink: PRGLink
            }
        })
    ], ProgressBarVue);
    return ProgressBarVue;
}(Vue));
export default ProgressBarVue;
